import React, { Component } from 'react';
import { mixin, RefluxMixin } from 'Util';
import CourseStore from 'stores/Course';
import CourseActions from 'actions/Course';
import NoteOverview from 'components/Notes/NotesOverview';

class NotesContainer extends mixin(RefluxMixin, Component) {
  listenToStores() {
    this.listenToStore(CourseStore);
  }

  componentDidMount() {
    CourseActions.findNotes(this.props.courseId);
  }
  render() {
    return (
      <div>
        {this.state.notes.map(course => (
          <NoteOverview id={course.id} course={course} notes={course.sections} {...this.props} />
        ))}
      </div>
    );
  }
}

export default NotesContainer;


// WEBPACK FOOTER //
// ./src/js/containers/NotesContainer.js